/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import { useHistory } from 'react-router-dom';

import { baseUrlApp } from '@/routes';

import ModalParametresInsee from './ModalParametresInsee';

/**
 * Point de menu « Paramètres > INSEE » : ouvre la modal de paramétrage et
 * revient à l'accueil à sa fermeture.
 */
const ParametresInsee = () => {
  const history = useHistory();

  const handleClose = React.useCallback(() => {
    history.push(baseUrlApp);
  }, [history]);

  return <ModalParametresInsee onClose={handleClose} />;
};

export default ParametresInsee;
